import { useState } from 'react';
import { apiFetch } from '../../hooks/apiFetch';
import { CartBooksSummary, CartOrdersSummary } from "../cart/CartSummery";
import { CartBooksItems, CartOrdersItmes } from "../cart/CartItems"
import Pagination from "../../utilities/Pagination";
import { allServicesCategories } from "../../data/CategoriesData"
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useUserCart } from '../../context/User/UserCartContext';

export default function MyCart() {
    const [error, setError] = useState(null);
    const { setValue } = useForm();
    const { t, i18n } = useTranslation();
    const {
        loading, cartBooks, setCartBooks, cartOrders,
        cartStats, setCartStats, currentPageBooks, setCurrentPageBooks,
        currentPageOrders, setCurrentPageOrders, setLoading
    } = useUserCart();

    const totalPagesBooks = cartBooks?.data?.paginationInfo.totalPagesCount;
    const totalPagesOrders = cartOrders?.data?.paginationInfo.totalPagesCount;

    const allCartDataBooks = cartBooks?.data?.result;
    const allCartDataOrders = cartOrders?.data?.result;


    async function cartOrderDelete(data, orderId) {
        setLoading(true);
        console.log("Form data: ", data, orderId); // Debug: Check form data
        // setValue("status", e.target.value)

        try {
            const response = await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/orders/${orderId}`, {
                method: "PATCH",
                body: JSON.stringify(data)
            });

            // Redirect to another page after successful submission
            if (response.isSuccess) {
                // navigate('/');
                // setTimeout(() => {
                //     window.location.reload();
                //     // navigate('/masarLibrary');
                // }, 3000);
                // setDataUpdate(true)
            } else {
                console.log(response, response.message, response.status);
                setError(t("errorTryAgain"), response.message);
            }
        } catch (error) {
            console.error("Error during form submission: ", error); // Debug: Check error
            setError(t("errorTryAgain"));
        } finally {
            setLoading(false);

            // navigate('/masarLibrary');

        }
    }


    async function cartBookDelete(id) {
        setLoading(true)
        try {
            await apiFetch(`${process.env.REACT_APP_MASAR_API_URL}/carts/book/${id}`, { method: "DELETE" });
            const updatedCartData = {
                ...cartBooks,
                data: {
                    ...cartBooks.data,
                    result: allCartDataBooks.filter((item) => item.id !== id)
                }
            };
            setCartBooks(updatedCartData);

            // Update cart stats based on the new cart data
            const updatedCartStats = {
                ...cartStats,
                data: {
                    totalBooks: updatedCartData.data.result.reduce((total, item) => total + item.quantity, 0),
                    totalPrice: updatedCartData.data.result.reduce((total, item) => total + (item.book.price * item.quantity), 0)
                }
            };
            setCartStats(updatedCartStats);

        } catch (err) {
            setError("هناك مشكلة في الحذف");
        } finally {
            setLoading(false)

        }
    }

    if (error) {
        return <div className="text-center my-4 text-danger">{error}</div>;
    }

    if (!cartBooks) {
        return <div className="loader" role="status" aria-live="polite" aria-label="Loading"></div>;
    }

    return (
        <div className="container my-3 rounded bg-dark-beige pt-2 pb-3">
            <div className="d-flex flex-column flex-md-row">
                {loading ?
                    <div className="loader-orange col-12 col-md-9"></div>
                    :
                    <div className="d-flex flex-wrap justify-content-around">
                        {allCartDataBooks.map((item) => (
                            <CartBooksItems key={item.id}
                                bookTitle={item.book.title}
                                bookQty={item.quantity}
                                bookImg={item.book?.thumbnail}
                                bookImgAlt={item.book.createdAt}
                                bookPrice={item.book.price}
                                handleOnClick={() => cartBookDelete(item.id)}
                                t={t}
                            />
                        ))}

                    </div>
                }
                <CartBooksSummary
                    totalBooks={cartStats?.data?.totalBooks}
                    totalBooksPrice={cartStats?.data?.totalBooksPrice}
                    t={t} />
            </div>
            {totalPagesBooks > 1 &&
                <Pagination
                    currentPage={currentPageBooks}
                    setCurrentPage={setCurrentPageBooks}
                    totalPages={totalPagesBooks} />
            }
            <div className="d-flex flex-column flex-md-row bg-white rounded mb-3">
                {loading ?
                    <div className="loader-orange col-12 col-md-9"></div>
                    :
                    <div className="d-flex flex-wrap flex-column col-12 col-md-9">
                        {allCartDataOrders.map((item) => (
                            <CartOrdersItmes
                                key={item.id}
                                t={t}
                                orderService={
                                    allServicesCategories.map(cat =>
                                        cat.en === item.service?.name ?
                                            (i18n.language === "ar" ? cat.ar : cat.en) : "")}
                                orderPrice={item.offerDetails?.price}
                                handleOnClick={(e) => {
                                    setValue("status", e.target.value);
                                    cartOrderDelete({ "status": "Rejected" }, item.id);
                                }}
                            />
                        ))}
                        {totalPagesOrders > 1 &&
                            <Pagination
                                currentPage={currentPageOrders}
                                setCurrentPage={setCurrentPageOrders}
                                totalPages={totalPagesOrders} />
                        }
                    </div>}
                <CartOrdersSummary
                    t={t}
                    totalOrders={cartStats?.data?.totalApprovedOrders}
                    totalOrdersPrice={cartStats?.data?.totalOrdersPrice} />
            </div>
        </div>
    );
};

// to Add 
// Ordar Approved or Rejected from user